export default {
  welcomeBack: "Welcome back",
      loadingPlan: "Loading your plan...",
      earnRewards: "Earn rewards by trying delicious meals today!",
      subscribePlan: "Subscribe to a plan and start earning rewards!",
      rewards: "Rewards",
      ourPartners: "Our Partners",
      trustedBy: "Trusted By Leading",
      availableMeals: "Available Meals",
      rewardsLeft: "rewards left",
      referralProgram: "Referral Program",
      inviteFriends: "Invite Friends",
      totalReferrals: "Total Referrals",
      referralEarnings: "Referral Earnings",
      earnUpTo: "Earn Up To $8,000 per Referral Tier",
      viewReferralProgram: "View Referral Program",
      rewardTiers: "Reward Tiers",
      guide: "Guide",
      agents: "agents",
  dulceCommercio: {
    "title": "Sweet Commerce",
    "description": "It is a third-party provider that processes UPI payments for major e-commerce systems.",
    "target": "Designed for all sellers, agents, and remote workers."
  }
};